export default {
  "buttons": [
    {
      id: 0,
      method: "$openPopupAddPlace",
      title: "billboard.add-object"
    }
  ]
}
